import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import { radioValidator } from "../../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.OWNER_GENERAL]: yup.object({
    [ComponentId.TYPE]: radioValidator,
  }),
};
